import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from '@resurs/midas-react'
import { getText } from '../../../internal/TextLabels/text'

const NewsDeleteDialog = ({ onConfirm, onClose }) => (
  <Modal
    title={getText('news.delete.title')}
    onClose={onClose}
    hideClose
    show
    actions={
      <div>
        <Button type="link" onClick={onClose}>
          {getText('default.close')}
        </Button>
        <Button type="primary" kind="danger" onClick={onConfirm}>
          {getText('default.delete')}
        </Button>
      </div>
    }
  >
    <p>
      {getText('news.delete.confirmQuestion')}
      <br />
      {getText('news.delete.confirmDesc')}
    </p>
  </Modal>
)

NewsDeleteDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default NewsDeleteDialog
